import { HttpClient } from '@angular/common/http'
import { inject } from '@angular/core'

type MenuItem = {
  enable: boolean
  lang1: string
  page_id: number
  page_parent: number
  page_sort: number
  showinmenu: boolean
  childrens: MenuItem[]
  detail?: MenuItem
  page: string
  type:
    | 'product'
    | 'static'
    | 'blog'
    | 'page'
    | 'topic'
    | 'external_link'
    | 'internal_link'
    | 'product_category'
    | 'blog_category'
    | 'product_tag'

  canonical_page_id: number
  canonical_type: string
  canonical_value: string
  is_canonical: number
  lang2: string
  lang3: string
  lang4: string
  path: string
  SEO_DES: string
  SEO_DES_lang1: string
  SEO_DES_lang2: string
  SEO_DES_lang3: string
  SEO_DES_lang4: string
  SEO_IMAGE: string
  SEO_IMAGE_lang1: string
  SEO_IMAGE_lang2: string
  SEO_IMAGE_lang3: string
  SEO_IMAGE_lang4: string
  SEO_KEYWORD: string
  SEO_KEYWORD_lang1: string
  SEO_KEYWORD_lang2: string
  SEO_KEYWORD_lang3: string
  SEO_KEYWORD_lang4: string
  SEO_TITLE: string
  SEO_TITLE_lang1: string
  SEO_TITLE_lang2: string
  SEO_TITLE_lang3: string
  SEO_TITLE_lang4: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setting: any
  display_name_lang1: string
  display_name_lang2: string
  display_name_lang3: string
  display_name_lang4: string
  display_type: string
}
type MainMenuSetting = {
  type: 'list' | 'table_column_banner' | 'column_banner'
  display_type: 'square' | 'round' | 'square_with_space'
  wrapper_type: 'square' | 'round' | 'round_with_space'
  display_arrow: boolean
  full_display: boolean
  gap_left_right: number
  colum_v2: boolean
  layout3?: {
    column: number
    perpage: number
  }
}
type SubMenuSetting = {
  column: number
  display_type: 'column' | 'banner'
  banner: {
    image: string
    image_size: string
    crop_image: boolean
    link: string
    custom_link: boolean
  }
}

export class CmsKetshopwebFrontendService {
  private http = inject(HttpClient)

  GetMenuSetting() {
    return this.http
      .get<{
        menu: MenuItem[]
        setting: {
          [key: string]: MainMenuSetting
        }
        sub_menu: {
          [key: string]: SubMenuSetting
        }
      }>('/services/ketshopweb-frontend/menu/menu_setting')
      .toPromise()
  }

  GetLayerMenu() {
    return this.http
      .get<{
        layer1: MenuItem[]
        layer2: MenuItem[]
      }>('/services/ketshopweb-frontend/menu/get_layer_menu')
      .toPromise()
  }

  // save_menu_setting
  SaveMenuSetting(data: {
    menu: MenuItem[]
    setting: {
      [key: string]: MainMenuSetting
    }
    sub_menu: {
      [key: string]: SubMenuSetting
    }
  }) {
    return this.http
      .post<{
        menu: MenuItem[]
        setting: {
          [key: string]: MainMenuSetting
        }
        sub_menu: {
          [key: string]: SubMenuSetting
        }
      }>('/services/ketshopweb-frontend/menu/save_menu_setting', data)
      .toPromise()
  }
}
